/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertising networks — Google AdSense for displaying advertisements. These partners may use cookies to serve personalized ads based on your browsing activity.`)
};

const es_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redes publicitarias — Google AdSense para mostrar anuncios. Estos socios pueden usar cookies para mostrar anuncios personalizados basados en tu actividad de navegación.`)
};

const de_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werbenetzwerke — Google AdSense für die Anzeige von Werbung. Diese Partner können Cookies verwenden, um personalisierte Werbung basierend auf Ihrem Surfverhalten anzuzeigen.`)
};

const nl_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertentienetwerken — Google AdSense voor het weergeven van advertenties. Deze partners kunnen cookies gebruiken om gepersonaliseerde advertenties weer te geven op basis van uw surfgedrag.`)
};

const fr_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réseaux publicitaires — Google AdSense pour l’affichage des publicités. Ces partenaires peuvent utiliser des cookies pour diffuser des annonces personnalisées basées sur votre activité de navigation.`)
};

const it_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reti pubblicitarie — Google AdSense per la visualizzazione di annunci pubblicitari. Questi partner possono utilizzare cookie per mostrare annunci personalizzati basati sulla tua attività di navigazione.`)
};

const pt_br2_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redes de publicidade — Google AdSense para exibição de anúncios. Esses parceiros podem usar cookies para exibir anúncios personalizados com base na sua atividade de navegação.`)
};

const pt_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redes publicitárias — Google AdSense para apresentação de anúncios. Estes parceiros podem utilizar cookies para apresentar anúncios personalizados com base na sua atividade de navegação.`)
};

const ja_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告ネットワーク — 広告表示のためのGoogle AdSense。これらのパートナーは閲覧活動に基づくパーソナライズ広告の配信にCookieを使用する場合があります。`)
};

const zh_privacy_third_party_ads = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`广告网络 — Google AdSense用于展示广告。这些合作伙伴可能使用Cookie根据您的浏览活动投放个性化广告。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_third_party_ads = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_third_party_ads(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_third_party_ads", locale)
	if (locale === "en") return en_privacy_third_party_ads(inputs)
	if (locale === "es") return es_privacy_third_party_ads(inputs)
	if (locale === "de") return de_privacy_third_party_ads(inputs)
	if (locale === "nl") return nl_privacy_third_party_ads(inputs)
	if (locale === "fr") return fr_privacy_third_party_ads(inputs)
	if (locale === "it") return it_privacy_third_party_ads(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_third_party_ads(inputs)
	if (locale === "pt") return pt_privacy_third_party_ads(inputs)
	if (locale === "ja") return ja_privacy_third_party_ads(inputs)
	return zh_privacy_third_party_ads(inputs)
};